import { useEffect, useState } from 'react';

/**
 * useTheme — auto dark/light for MilleHills Admin
 * Priority:
 *   1. System preference (prefers-color-scheme)
 *   2. Time of day fallback — light 06:00–19:00, dark otherwise
 */
export function useTheme() {
  const getTimeBasedTheme = () => {
    const hour = new Date().getHours();
    return hour >= 6 && hour < 19 ? 'light' : 'dark';
  };

  const getTheme = () => {
    const mqLight = window.matchMedia('(prefers-color-scheme: light)');
    const mqDark  = window.matchMedia('(prefers-color-scheme: dark)');
    if (mqLight.matches) return 'light';
    if (mqDark.matches)  return 'dark';
    return getTimeBasedTheme();
  };

  const [theme, setTheme] = useState(getTheme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  useEffect(() => {
    const mqLight = window.matchMedia('(prefers-color-scheme: light)');
    const mqDark  = window.matchMedia('(prefers-color-scheme: dark)');

    const handler = () => setTheme(getTheme());
    mqLight.addEventListener('change', handler);
    mqDark.addEventListener('change', handler);

    const interval = setInterval(() => {
      const l = window.matchMedia('(prefers-color-scheme: light)');
      const d = window.matchMedia('(prefers-color-scheme: dark)');
      if (!l.matches && !d.matches) setTheme(getTimeBasedTheme());
    }, 60 * 1000);

    return () => {
      mqLight.removeEventListener('change', handler);
      mqDark.removeEventListener('change', handler);
      clearInterval(interval);
    };
  }, []);

  return theme;
}